import 'unfetch/polyfill'
import 'promise-polyfill/dist/polyfill';
const sortProperties = document.getElementById('sort-properties');
const propertiesResults = document.querySelector('.propertiesResults');
const loaderContainer = document.querySelector('.loaderContainer');

if (sortProperties) {
    sortProperties.addEventListener('change', () => {
        let url = window.location.href;
        let filterUrl = url + "?filter=" + sortProperties.value;

        fetch(filterUrl, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        }).then(response => {
            return response.text();
        }).then( (html) => {
            let parser = new DOMParser();
            let doc = parser.parseFromString(html, 'text/html');
			propertiesResults.classList.add('is-loading');
			loaderContainer.classList.add('is-active');

			setTimeout( () => {
				propertiesResults.innerHTML = '';
				propertiesResults.appendChild(doc.querySelector('.propertiesResults'));
			}, 500);

			setTimeout(() => {
				propertiesResults.classList.remove('is-loading');
				loaderContainer.classList.remove('is-active');
			}, 1500);

        }).catch(function (err) {
            // There was an error
            console.warn('Something went wrong.', err);
        });
    })
}
